import React, { FunctionComponent } from "react";
import { FormInputNumber, FormRow } from "../../../components/formRow/FormRow";

interface WidgetPositionControlsProps {
    idPrefix: string;
    columnStart: number | string;
    width: number | string;
    rowStart: number | string;
    height: number | string;
    handlers: {
        handleColumnStartChange: (value: string) => void;
        handleWidthChange: (value: string) => void;
        handleRowStartChange: (value: string) => void;
        handleHeightChange: (value: string) => void;
        handleColumnStartBlur: (value: string) => void;
        handleWidthBlur: (value: string) => void;
        handleRowStartBlur: (value: string) => void;
        handleHeightBlur: (value: string) => void;
    };
    isOutOfLimit: boolean;
    maxElements: number;
    validationError?: string;
}

export const WidgetPositionControls: FunctionComponent<WidgetPositionControlsProps> = ({
    idPrefix, columnStart, width, rowStart, height,
    handlers, isOutOfLimit, maxElements, validationError
}) => {
    const rowClassnames = `mosaic-settings-add-elem ${isOutOfLimit ? 'out-of-limit' : ''}`;

    return (
        <>
            <div className={rowClassnames}>
                {isOutOfLimit && (
                    <span className="info-message">
                        {`You can have ${maxElements} elements of this type`}
                    </span>
                )}
                <FormRow>
                    <FormInputNumber
                        id={`${idPrefix}-column-start`}
                        title="Column Start"
                        isError={false}
                        errorMessage="Please enter column start"
                        onChangeValue={handlers.handleColumnStartChange}
                        onBlurFires={handlers.handleColumnStartBlur}
                        onChange={() => {}}
                        value={columnStart}
                    />
                </FormRow>
                <FormRow>
                    <FormInputNumber
                        id={`${idPrefix}-width`}
                        title="Width"
                        isError={false}
                        errorMessage="Please enter width"
                        onChangeValue={handlers.handleWidthChange}
                        onBlurFires={handlers.handleWidthBlur}
                        onChange={() => {}}
                        value={width}
                    />
                </FormRow>
                <FormRow>
                    <FormInputNumber
                        id={`${idPrefix}-row-start`}
                        title="Row Start"
                        isError={false}
                        errorMessage="Please enter row start"
                        onChangeValue={handlers.handleRowStartChange}
                        onBlurFires={handlers.handleRowStartBlur}
                        onChange={() => {}}
                        value={rowStart}
                    />
                </FormRow>
                <FormRow>
                    <FormInputNumber
                        id={`${idPrefix}-height`}
                        title="Height"
                        isError={false}
                        errorMessage="Please enter height"
                        onChangeValue={handlers.handleHeightChange}
                        onBlurFires={handlers.handleHeightBlur}
                        onChange={() => {}}
                        value={height}
                    />
                </FormRow>
            </div>
            {validationError && <span className="error">{validationError}</span>}
        </>
    );
};
